export type SpecificationMode = 'old_new' | 'difference';
export type SpecificationRole = 'old' | 'new' | 'difference';

export const ROLES_BY_MODE: Record<SpecificationMode, readonly SpecificationRole[]> = {
  old_new: ['old', 'new'],
  difference: ['difference'],
};

/** Reference only: the extracted text never travels in the field value. */
export interface SelectedSpecificationDocument {
  documentId: string;
  versionId: string | null;
  title: string;
  fileName?: string;
}

/** Only the active value is submitted; manual and edited drafts are retained separately. */
export type SpecificationFieldValue =
  | { kind: 'text'; text: string }
  | { kind: 'derived'; text: string; origin: SelectedSpecificationDocument }
  | ({ kind: 'document' } & SelectedSpecificationDocument);

export type SpecificationSourceKind = SpecificationFieldValue['kind'];

export type FirstRunSpecifications =
  | { mode: 'old_new'; old: SpecificationFieldValue; new: SpecificationFieldValue }
  | { mode: 'difference'; difference: SpecificationFieldValue };

/** What the start action hands to #1637; the inactive mode's fields are never in it. */
export interface FirstRunInputSubmission {
  itemName: string;
  title: string;
  cadModelId?: string;
  supplement: string;
  specifications: FirstRunSpecifications;
}

/** The registered-document source (#1636). Cancelling its picker must not call onChange. */
export interface DocumentSourceSlotProps {
  role: SpecificationRole;
  value: SelectedSpecificationDocument | null;
  onChange: (document: SelectedSpecificationDocument | null) => void;
  onEditCopy?: (document: SelectedSpecificationDocument, text: string) => void;
  disabled: boolean;
}
